module.exports = __webpack_public_path__ + "static/media/blue-dot.5d2a2593.svg";